<template>
  <div
    class="
      absolute
      top-6
      right-6
      cursor-pointer
      rounded
      py-4
      px-3
      flex
      justify-center
      items-center
      menu
    "
    @click="setIsFooterOpen(true)"
    :class="themeIsDark || isDark ? 'bg-black text-white' : 'bg-white text-black'"
  >
    <Icon id="menu" :color="themeIsDark || isDark ? '#fff' : '#000'" />
  </div>
</template>

<script lang="ts">
import { Prop, Component, Vue } from 'vue-property-decorator'
import { Getter, Mutation } from 'vuex-class'

@Component({
  components: {
  }
})
export default class NavMenu extends Vue {
  @Prop() isDark!: boolean

  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string

  @Mutation('SET_IS_FOOTER_OPPEN') setIsFooterOpen!: (val: boolean) => void
}

</script>
